import React, { useState, useEffect } from "react";
import LayoutV2 from "containers/LayoutV2";
import KySoAPI from "service/In/KySoAPI";
import { formatNumber } from "utils/currencyFormat";

export const KiemTraKySo = () => {
  const [fileToCheck, setFileToCheck] = useState(null);
  const [checkStatus, setCheckStatus] = useState(null);
  const [resultData, setResultData] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [status, setStatus] = useState(null);
  const [hopDong, setHopDong] = useState(null);
  const [loading, setLoading] = useState(false);
  const currentStep = checkStatus ? 3 : fileToCheck ? 2 : 1;
  const fileInputRef = React.useRef(null);

  const renderStep = (step, title, subtitle) => {
    const active = currentStep >= step;
    return (
      <div
        key={step}
        style={{
          flex: 1,
          minWidth: 170,
          padding: "14px 16px",
          borderRadius: 12,
          backgroundColor: active ? "#e9f4ff" : "#f7f7f7",
          border: active ? "1px solid #1d72e8" : "1px solid #d8d8d8",
          boxShadow: active ? "0 2px 6px rgba(29, 114, 232, 0.12)" : "none",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: active ? "#1d72e8" : "#a8a8a8",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
            }}
          >
            {step}
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 12, color: "#5a5a5a", marginBottom: 4 }}>
              {subtitle}
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: active ? "#1d72e8" : "#333",
              }}
            >
              {title}
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    document.title = "Kiểm tra ký số | Phần mềm quản lý cầm đồ Morman";
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      setFileToCheck(null);
      setCheckStatus(null);
      setResultData(null);
      return;
    }

    if (file.type !== "application/pdf") {
      setCheckStatus({
        type: "error",
        message: "Vui lòng chọn file PDF.",
      });
      setFileToCheck(null);
      setResultData(null);
      return;
    }

    setFileToCheck(file);
    setCheckStatus(null);
    setResultData(null);
  };

  const handleCheckKySo = async () => {
    if (!fileToCheck) {
      setCheckStatus({
        type: "error",
        message: "Bạn cần chọn File!",
      });
      return;
    }

    setIsChecking(true);
    setCheckStatus(null);
    setResultData(null);

    try {
      //   const result = await KySoAPI.checkSignedPDF(fileToCheck);
      //   setResultData(result);

      //   const isValid =
      //     result === true ||
      //     result?.TrangThai === 1 ||
      //     result?.trangThai === 1 ||
      //     result?.status === "valid" ||
      //     result?.status === "success" ||
      //     result?.success === true ||
      //     result?.valid === true;

      //   if (!isValid) {
      //     throw new Error();
      //   }
      // console.log("fileToCheck:", fileToCheck);
      // console.log("instanceof File:", fileToCheck instanceof File);
      // console.log("name:", fileToCheck.name);
      // console.log("size:", fileToCheck.size);
      // console.log("originFileObj:", fileToCheck.originFileObj);

      const result = await KySoAPI.checkSignedPDF(fileToCheck);

      // 👉 CASE 1: đã ký (backend trả về chovay)
      if (result && result.ChoVayId) {
        setStatus("signed");
        setHopDong(result);
        setResultData(result);
        setCheckStatus({
          type: "success",
          message: "Hợp đồng hợp lệ",
        });
      }
      // 👉 CASE 2: chưa ký
      else {
        setStatus("unsigned");
        setHopDong(null);
        setCheckStatus({
          type: "error",
          message: "Hợp đồng chưa được ký số hoặc không hợp lệ",
        });
      }
    } catch (error) {
      setCheckStatus({
        type: "error",
        message:
          "File hợp đồng không hợp lệ hoặc đã bị thay đổi. Vui lòng kiểm tra lại",
      });
      setResultData(null);
    } finally {
      setIsChecking(false);
    }
  };

  const handleResetStep = () => {
    setFileToCheck(null);
    setCheckStatus(null);
    setResultData(null);
    setStatus(null);
    setHopDong(null);

    // 🔥 reset input file
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new hidden-mobile-main show-table-main">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div className="row header">
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/logo-tragop-v2.png"
                          alt=""
                        />
                        <h1 className="text-info-home">Kiểm tra ký số</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="card border-light mb-3 card-v2"
          style={{ marginLeft: "15px", marginRight: "15px" }}
        >
          <div className="card-body card-body-v2">
            <div
              style={{
                display: "flex",
                gap: 16,
                marginBottom: 20,
                flexWrap: "wrap",
              }}
            >
              {renderStep(1, "Chọn file PDF", "Bước 1")}
              {renderStep(2, "Kiểm tra dữ liệu", "Bước 2")}
              {renderStep(3, "Kết quả", "Bước 3")}
            </div>
            <div className="body-detail-bc" style={{ color: "black" }}>
              <div
                className="alert alert-light"
                style={{ marginBottom: 20, border: "1px solid #d8d8d8" }}
              >
                <strong>Thông tin hướng dẫn:</strong>
                <ul style={{ marginTop: 10, marginBottom: 0, paddingLeft: 20 }}>
                  <li>
                    Chỉ hỗ trợ file PDF đã được ký xác thực từ hệ thống Morman.
                  </li>
                  <li>Không chỉnh sửa file trước khi kiểm tra.</li>
                </ul>
              </div>
              {/* <div className="col-lg-2 col-md-6 col-sm-10">
                <div className="form-group">
                  <label className="font-color-default font-bold">
                    Loại hợp đồng
                  </label>
                  <select className="form-control">
                    <option value="-1">Tất cả</option>
                    <option value="3">Cho vay</option>
                    <option value="1">Nhận vay</option>
                  </select>
                </div>
              </div> */}
              <div className="form-money-2" style={{ marginBottom: "5px" }}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>Upload file PDF cần kiểm tra</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="application/pdf"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />
                    </div>
                    {fileToCheck && (
                      <div className="alert alert-info" role="alert">
                        File đã chọn: {fileToCheck.name}
                      </div>
                    )}
                    {checkStatus && (
                      <div
                        className={`alert alert-${
                          checkStatus.type === "success" ? "success" : "danger"
                        }`}
                        role="alert"
                      >
                        {checkStatus.message}
                      </div>
                    )}
                    {/* {resultData && checkStatus?.type === "success" && (
                      <div
                        className="card border-success mb-3"
                        style={{ padding: 16 }}
                      >
                        <div className="font-weight-bold mb-2">
                          Thông tin hợp đồng
                        </div>
                        <div style={{ fontSize: 14, marginBottom: 8 }}>
                          File được tạo từ hệ thống Morman.
                        </div>
                        {resultData?.SoHopDong && (
                          <div>Mã hợp đồng: {resultData.SoHopDong}</div>
                        )}
                        {resultData?.MaHopDong && (
                          <div>Mã hợp đồng: {resultData.MaHopDong}</div>
                        )}
                        {resultData?.TenKhachHang && (
                          <div>Tên khách hàng: {resultData.TenKhachHang}</div>
                        )}
                        {resultData?.NgayKy && (
                          <div>Ngày ký: {resultData.NgayKy}</div>
                        )}
                        {resultData?.NguoiKy && (
                          <div>Người ký: {resultData.NguoiKy}</div>
                        )}
                      </div>
                    )} */}
                    <button
                      className="btn btn-new-main btn-checknew"
                      onClick={handleCheckKySo}
                      disabled={isChecking}
                      type="button"
                    >
                      <span>
                        <img src="/app-assets/images/icon-save-v2-white.png" />
                      </span>
                      &nbsp;
                      {isChecking
                        ? "Đang kiểm tra hợp đồng"
                        : "Kiểm tra dữ liệu"}
                      &nbsp;
                    </button>
                    &nbsp;
                    {checkStatus && (
                      <button
                        className="btn btn-new-main btn-closenew"
                        onClick={handleResetStep}
                        type="button"
                      >
                        Refresh
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              {loading && <p>Đang kiểm tra ký số...</p>}

              {/* ĐÃ KÝ */}
              {status === "signed" && hopDong && (
                <div>
                  <h3 className="color-do-bold">✔ ĐÃ KÝ HỢP ĐỒNG</h3>

                  <p className="color7-bold">Mã hợp đồng: {hopDong.Code}</p>
                  <p className="color7-bold">
                    Khách hàng: {hopDong.CustomerName}
                  </p>
                  <p className="color7-bold">
                    Số tiền: {formatNumber(hopDong.SoTienVay)} VND
                  </p>
                  <p className="color7-bold">Ngày vay: {hopDong.NgayVay}</p>
                </div>
              )}

              {/* CHƯA KÝ */}
              {status === "unsigned" && (
                <div style={{ color: "red" }}>
                  <h3>✖ CHƯA KÝ HỢP ĐỒNG</h3>
                  <p>File PDF này chưa có chữ ký số hợp lệ</p>
                </div>
              )}

              {/* ERROR */}
              {status === "error" && (
                <div style={{ color: "orange" }}>Lỗi khi kiểm tra chữ ký</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </LayoutV2>
  );
};
